"use strict";

var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _weakMap = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/weak-map"));
var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));
var _httpCore = require("@webex/http-core");
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } } /*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */
var rateLimitExpiryTime = new _weakMap.default();
/**
 * @class
 */
var LocusRetryStatusInterceptor = exports.default = /*#__PURE__*/function (_Interceptor) {
  (0, _inherits2.default)(LocusRetryStatusInterceptor, _Interceptor);
  var _super = _createSuper(LocusRetryStatusInterceptor);
  function LocusRetryStatusInterceptor() {
    (0, _classCallCheck2.default)(this, LocusRetryStatusInterceptor);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(LocusRetryStatusInterceptor, [{
    key: "onResponseError",
    value:
    /**
     * Handle response errors
     * @param {Object} options
     * @param {WebexHttpError} reason
     * @returns {Promise<WebexHttpError>}
     */
    function onResponseError(options, reason) {
      if ((reason.statusCode === 503 || reason.statusCode === 429) && options.uri.includes('locus')) {
        var hasRetriedLocusRequest = rateLimitExpiryTime.get(this);
        var retryAfterTime = options.headers['retry-after'] || 2000;
        if (hasRetriedLocusRequest) {
          rateLimitExpiryTime.set(this, false);
          return _promise.default.reject(options);
        }
        rateLimitExpiryTime.set(this, true);
        return this.handleRetryRequestLocusServiceError(options, retryAfterTime);
      }
      return _promise.default.reject(reason);
    }

    /**
     * Handle retries for locus service unavailable errors
     * @param {Object} options associated with the request
     * @param {number} retryAfterTime retry after time in milliseconds
     * @returns {Promise}
     */
  }, {
    key: "handleRetryRequestLocusServiceError",
    value: function handleRetryRequestLocusServiceError(options, retryAfterTime) {
      var _this = this;
      return new _promise.default(function (resolve, reject) {
        var timeout = setTimeout(function () {
          clearTimeout(timeout);

          // @ts-ignore
          _this.webex.request({
            method: options.method,
            uri: options.uri,
            body: options.body
          }).then(resolve).catch(reject);
        }, retryAfterTime);
      });
    }
  }], [{
    key: "create",
    value:
    /**
     * @returns {LocusRetryStatusInterceptor}
     */
    function create() {
      // @ts-ignore
      return new LocusRetryStatusInterceptor({
        webex: this
      });
    }
  }]);
  return LocusRetryStatusInterceptor;
}(_httpCore.Interceptor);
//# sourceMappingURL=locusRetry.js.map
